import z from 'zod'

export let claimSchema = z.object({
  id: z.string(),

  service_date: z.string()
    .nullable()
    .optional(),

  claim_number: z.string()
    .nullable()
    .optional(),

  provider_name: z.string()
    .nullable()
    .optional(),

  procedure: z.object({
    code: z.string()
      .nullable()
      .optional(),

    descriptor: z.string()
      .nullable()
      .optional()
  })
    .nullable()
    .optional(),

  billing_date: z.string()
    .nullable()
    .optional(),

  paid_date: z.string()
    .nullable()
    .optional(),

  charge_amount: z.number()
    .nullable()
    .optional(),

  ppo_discount: z.number()
    .nullable()
    .optional(),

  ineligible_amount: z.number()
    .nullable()
    .optional(),

  deductible: z.number()
    .nullable()
    .optional(),

  out_of_pocket: z.number()
    .nullable()
    .optional(),

  coinsurance: z.number()
    .nullable()
    .optional(),

  total_paid: z.number()
    .nullable()
    .optional(),

  place_of_service: z.string()
    .nullable()
    .optional(),

  claim_status: z.string()
    .nullable()
    .optional(),

  description: z.array(
    z.object({
      code: z.string()
        .nullable()
        .optional(),

      descriptor: z.string()
        .nullable()
        .optional()
    })
  )
    .nullable()
    .optional()
})

export let claimsSchema = z.array(claimSchema)
